import { render, staticRenderFns } from "./EditVM.vue?vue&type=template&id=ef67aed6&scoped=true&"
import script from "./EditVM.vue?vue&type=script&lang=js&"
export * from "./EditVM.vue?vue&type=script&lang=js&"
import style0 from "./EditVM.vue?vue&type=style&index=0&id=ef67aed6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef67aed6",
  null
  
)

export default component.exports